import { Price } from '@src/types';

export const checkPrices = (
  oldPrice: Price,
  newPrice: Price,
  hasPromo: boolean
) =>
  hasPromo
    ? oldPrice.premiumAndDeltaPromo === newPrice.premiumAndDeltaPromo
    : oldPrice.premiumAndDelta === newPrice.premiumAndDelta;
